module.exports = __webpack_public_path__ + "img/yispiao.4d80a07f.svg";